import React from 'react';
import PropTypes from 'prop-types';
import ClearableInput from '../ClearableInput';

const CursorInput = ({
  getRef,
  onPrevious,
  onNext,
  showCursors,
  disablePrevious,
  disableNext,
  ...rest
}) => (
  <div className="cursor-input-container">
    { showCursors &&
      <button
        className={`cursor-button previous-button ${disablePrevious ? 'disabled' : ''}`}
        type="submit"
        onClick={onPrevious}
        disabled={disablePrevious}
      >
        <i className="fa fa-arrow-left" />
      </button>
    }
    <ClearableInput
      getRef={getRef}
      {...rest}
    />
    { showCursors &&
      <button
        className={`cursor-button next-button ${disableNext ? 'disabled' : ''}`}
        type="submit"
        onClick={onNext}
        disabled={disableNext}
      >
        <i className="fa fa-arrow-right" />
      </button>
    }
  </div>
);

CursorInput.defaultProps = {
  showCursors: false,
  disablePrevious: false,
  disableNext: false,
  getRef: undefined,
};

CursorInput.propTypes = {
  /** Returns the component reference */
  getRef: PropTypes.any,
  /** Callback to be called when clicking on back button */
  onPrevious: PropTypes.func.isRequired,
  /** Callback to be called when clicking on next button */
  onNext: PropTypes.func.isRequired,
  /** Indicate if cursors button should be shown */
  showCursors: PropTypes.bool,
  /** Disable previous cursor button */
  disablePrevious: PropTypes.bool,
  /** Disable next cursor button */
  disableNext: PropTypes.bool,
  /** Value to input */
  value: PropTypes.string.isRequired,
  /** Callback to be called when clicking on clean icon */
  onClear: PropTypes.func.isRequired,
};

export default CursorInput;
